import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Autocomplete, Box, Button, CircularProgress, Divider, Grid, IconButton, Modal, Stack, TextField, Typography } from '@mui/material'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { useForm } from '../../../../hooks';
import { style } from '../../../../helpers/editStyle';
import { NumberInput } from '../../NumberInput';
import { useEffect, useState } from 'react';
import { fetchData } from '../../../helpers/getData/fetchData';
import { unSelectContribution } from '../../../../store/contributions/contributionSlice';
import { editInvestmentFund } from '../../../helpers/investmentFunds';
import { DateInput } from '../../DateInput';


export const EditContributions = ({ setHidden, setReloadData }) => {

    const { t } = useTranslation('global');
    const { dataToAction } = useSelector(state => state.contribution)
    const [companiesList, setCompaniesList] = useState('isLoading')

    const dispatch = useDispatch();
    const [formValues, handleInputChange, reset] = useForm(dataToAction);

    const { whoInvest, amount, investmentDate } = formValues;

    const handleCancel = () => {
        reset()
        dispatch(unSelectContribution())
        setHidden(false)
    }
    const onSubmit = (e) => {
        e.preventDefault();
        editInvestmentFund(formValues, t('contributions.successEditMsg'), t('contributions.errorEditMsg'))
        setReloadData(prevState => !prevState)
        setHidden(false)
    }

    useEffect(() => {
        fetchData(setCompaniesList, `/companies/listNameQuery?name=${dataToAction.individualId}`, t)
    }, [t, dataToAction.individualId])

    return (
        <Modal
            open={true}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            sx={{ zIndex: 9999 }}
        >
            {
                companiesList !== 'isLoading' ?

                    <Box sx={style}>
                        <Stack direction='row' justifyContent='space-between' alignItems='baseline' sx={{ height: '50px' }}>
                            <Typography color='primary' marginBottom='10px' variant='h5' fontWeight={700}>{t('contributions.editContribution')}</Typography>
                            <IconButton color='primary' onClick={handleCancel}>
                                <CloseRoundedIcon />
                            </IconButton>
                        </Stack>
                        <form onSubmit={onSubmit} style={{ padding: '10px 5px', display: 'flex', flexDirection: 'column', justifyContent: 'space-around' }}>
                            <Stack sx={{ height: 'calc(70vh - 200px)', overflowY: 'auto', paddingBottom: '10px', paddingRight: '20px' }}>

                                <Grid container direction='row' width='100%' >
                                    <Grid item xs={12} padding='0 5px'>
                                        <Typography variant='overline' color='secondary'>{t('contributions.whoInvest')}</Typography>
                                        <Autocomplete
                                            disablePortal
                                            options={[...companiesList, `${dataToAction.name} ${dataToAction.surnames}`]}
                                            size='small'
                                            renderInput={(params) => <TextField  {...params} variant='outlined' name='whoInvest' />}
                                            value={whoInvest}
                                            onSelect={handleInputChange}
                                            fullWidth
                                            required
                                        />
                                    </Grid>
                                </Grid>


                                <Grid container direction='row' width='100%' >
                                    <Grid item xs={12} padding='0 5px'>
                                        <NumberInput name={amount} title={'amount'} handleInputChange={handleInputChange} min={100000} />
                                    </Grid>
                                </Grid>

                                <Grid container direction='row' width='100%' >
                                    <Grid item xs={12} padding='0 5px'>
                                        <DateInput name={investmentDate} title={'investmentDate'} handleInputChange={handleInputChange} />
                                    </Grid>
                                </Grid>

                            </Stack>

                            <Stack sx={{ heigth: '80px' }}>
                                <Divider sx={{ margin: '30px 0px 15px 0px' }} />

                                <Grid container direction='row' width='100%' >
                                    <Grid item xs={12} md={6} padding='0 5px'>
                                        <Button fullWidth onClick={handleCancel} variant="text">{t("createPassword.cancelButton")}</Button>
                                    </Grid>
                                    <Grid item xs={12} md={6} padding='0 5px'>
                                        <Button fullWidth type='submit' variant="contained">{t("createPassword.principalButton")}</Button>
                                    </Grid>
                                </Grid>
                            </Stack>
                        </form>

                    </Box>
                    :
                    <Stack width='100%' alignItems='center' marginTop='100px'>
                        <CircularProgress />
                    </Stack>
            }
        </Modal>
    )
}